import { ref } from 'vue';

export function usePagination() {
  const pagination = ref({
    page: 1,
    limit: 25,
    total: 0,
  });
  const loading = ref(false);

  const paginate = (page: number) => {
    pagination.value = { ...pagination.value, page };
  };

  const setTotal = (total: number) => {
    pagination.value.total = total;
  };

  return {
    loading,
    pagination,
    paginate,
    setTotal,
  };
}
